export function parseJsonLintError(
  errorMessage: string
): { line: number; column: number } | null {
  const lines = errorMessage.split("\n");

  // Rechercher la ligne contenant "Parse error on line X:"
  const errorLineMatch = lines[0].match(/Parse error on line (\d+)/i);
  if (!errorLineMatch) {
    return null;
  }

  const line = parseInt(errorLineMatch[1], 10);

  // Rechercher la ligne contenant le caret '^'
  const caretLineIndex = lines.findIndex((line) => line.includes("^"));
  if (caretLineIndex === -1) {
    return null;
  }

  // La ligne précédente contient les tirets indiquant la position
  const hyphensLine = lines[caretLineIndex];
  if (!hyphensLine) {
    return null;
  }

  // Compter le nombre de tirets avant le caret pour déterminer la colonne
  const caretPos = hyphensLine.indexOf("^");
  if (caretPos === -1) {
    return null;
  }

  // Les index sont 0-based, donc ajouter 1 pour obtenir la colonne 1-based
  const column = caretPos + 1;

  return { line, column };
}

export function getOffset(text: string, line: number, column: number): number {
  const lines = text.split("\n");
  let offset = 0;
  for (let i = 0; i < line - 1; i++) {
    offset += lines[i].length + 1;
  }
  return offset + column - 1;
}
